import { QuestionStep } from '../QuestionStep';
import { MultiChip } from './_shared';
import {
  FEATURE_OPTIONS,
  STEPS,
  type QuestionnaireAnswers,
} from '../questions';

interface FeaturesStepProps {
  answers: QuestionnaireAnswers;
  onChange: (next: Partial<QuestionnaireAnswers>) => void;
}

export function FeaturesStep({ answers, onChange }: FeaturesStepProps) {
  const step = STEPS.find((s) => s.id === 'features')!;
  return (
    <QuestionStep step={step}>
      <MultiChip
        options={FEATURE_OPTIONS}
        values={answers.features ?? []}
        onChange={(v) => onChange({ features: v })}
        exclusiveValue="none"
      />
      <p className="mt-6 max-w-xl font-mono text-[11px] text-graphite leading-relaxed">
        <span className="text-ochre">¶</span>&nbsp;&nbsp;Anything you want that isn't shown in your sketches. Selecting "None of the above" clears the others.
      </p>
    </QuestionStep>
  );
}
